import { SubscriptionVariants } from "../types/rtk/subscription/subscription";

/**
 * Calculates the difference between two subscription periods
 * @param offers - List of available subscription offers
 * @param cheaperPeriod - Period of the cheaper offer (in months)
 * @param expensivePeriod - Period of the more expensive offer (in months)
 * @param mode - "percent": savings percentage | "amount": annual price difference in cents
 * @returns The calculated value, or null if calculation is not possible
 */
export const calculateSavingsBetweenPeriods = (
  offers: SubscriptionVariants[],
  cheaperPeriod: number,
  expensivePeriod: number,
  mode: "percent" | "amount" = "percent"
): number | null => {
  if (!offers || offers.length < 2) return null;

  const cheaperOffer   = offers.find(sub => sub.period === cheaperPeriod);
  const expensiveOffer = offers.find(sub => sub.period === expensivePeriod);

  if (!cheaperOffer?.price?.amount || !expensiveOffer?.price?.amount) return null;

  const cheaperMonthly   = cheaperOffer.price.amount   / cheaperOffer.period;
  const expensiveMonthly = expensiveOffer.price.amount / expensiveOffer.period;

  if (mode === "amount") {
    return Math.round((expensiveMonthly - cheaperMonthly) * 12 * 100) / 100;
  }

  return Math.ceil((1 - cheaperMonthly / expensiveMonthly) * 100);
};
